module.exports = __webpack_public_path__ + "static/img/company_introduce1.b5fd57c7.jpg";